export default ["en", "ru", "uk"];
